import adminPhoto from 'assets/img/vacancies-v4/admin.jpg';
import specialistPhoto from 'assets/img/vacancies-v4/specialist.jpg';
import correctorPhoto from 'assets/img/vacancies-v4/corrector.jpg';
import introSide from 'assets/img/vacancies-v4/intro-side.png';
import deptKvd from 'assets/img/vacancies-v4/dept-kvd.jpg';
import deptExport from 'assets/img/vacancies-v4/dept-export.jpg';
import deptIndustry from 'assets/img/vacancies-v4/dept-industry.jpg';
import linkNews from 'assets/img/vacancies-v4/link-news.png';
import linkEvents from 'assets/img/vacancies-v4/link-events.png';
import linkResolutions from 'assets/img/vacancies-v4/link-resolutions.png';
import linkAnalytics from 'assets/img/vacancies-v4/link-analytics.png';
import { routes } from 'appConstants';

export type VacancyPoint = {
  title: string;
  text: string;
};

export type Vacancy = {
  id: string;
  cardTitle: string;
  fullTitle: string;
  photo: string;
  tasks: string[];
  fit: VacancyPoint[];
  offer: VacancyPoint[];
};

export const INTRO_TITLE = 'АНО «Моспром» – продвигаем промышленный потенциал Москвы';

export const INTRO_TEXT_LEAD = 'Присоединяйтесь к команде АНО «Моспром» –';

export const INTRO_TEXT_REST =
  ' организации, созданной Правительством Москвы для поддержки, развития и продвижения столичной промышленности. Мы помогаем московским предприятиям выходить на международные рынки, организуем масштабные отраслевые мероприятия, проводим аналитические исследования и реализуем спецпроекты, направленные на популяризацию промышленного сектора.';

export const INTRO_SIDE = introSide;

export const VACANCIES: Vacancy[] = [
  {
    id: 'admin',
    cardTitle: 'Администратор проекта',
    fullTitle:
      'Администратор проекта\nУправления специальных проектов\nи конгрессно-выставочной деятельности',
    photo: adminPhoto,
    tasks: [
      'Координация профильных форумов и мероприятий.',
      'Работа с проектной документацией (технические задания, программы мероприятий, регламенты, протоколы).',
      'Взаимодействие с подрядчиками и контроль выполнения договорных обязательств в рамках реализации таких проектов как: "Открой#Моспром", Династии московской промышленности, ВК-фест и другие.',
      'Работа с партнёрами – привлечение и взаимодействие с ключевыми игроками отрасли, работа с гос.сектором и подведомственными организациями, институтами развития.',
      'Реализация собственных профильных мероприятий и форумов – от идеи и концепции проекта до его проведения.',
      'Подготовка отчётных материалов, аналитических справок и презентаций.',
      'Ведение полного цикла документооборота по проектам (входящие/исходящие документы, согласования, архивирование).',
      'Работа с системой МосЭДО, контроль сроков исполнения поручений.',
    ],
    fit: [
      {
        title: 'Есть профильное образование.',
        text: 'Вы окончили вуз по направлению «Менеджмент», «Государственное и муниципальное управление».',
      },
      {
        title: 'Наработали практический опыт.',
        text: 'Не менее 2 лет работали в федеральных или столичных органах исполнительной власти или госкорпорациях, учреждениях по работе с молодёжью.',
      },
      {
        title: 'Умеете организовывать события.',
        text: 'Опыт подготовки массовых мероприятий.',
      },
      {
        title: 'Владеете офисными инструментами.',
        text: 'Готовите документы, сводите таблицы, делаете презентации.',
      },
      {
        title: 'Обладаете «мягкими» навыками.',
        text: 'Ответственно подходите к задачам, легко находите общий язык с людьми, умеете работать в условиях многозадачности и сохранять хладнокровие.',
      },
      {
        title: 'Готовы к динамичной работе.',
        text: 'Понимаете, что иногда потребуется выйти за рамки стандартного графика.',
      },
      {
        title: 'Знаете правила делового общения.',
        text: 'Ориентируетесь в нормах этикета: от переписки до личных встреч.',
      },
    ],
    offer: [
      {
        title: 'Достойное вознаграждение.',
        text: 'Предлагаем конкурентоспособную зарплату.',
      },
      {
        title: 'Заряжающие энергией задачи.',
        text: 'Интересные, масштабные проекты и все необходимые ресурсы для их воплощения.',
      },
      {
        title: 'Проекты уровня первых лиц.',
        text: 'Вы будете участвовать в организации мероприятий с участием руководства Правительства Москвы – это уникальный опыт и возможность увидеть работу системы изнутри.',
      },
      {
        title: 'Работа с молодёжной аудиторией.',
        text: 'Самая динамичная и заряжающая целевая аудитория. Вы сможете влиять на формирование профессионального будущего ребят.',
      },
      {
        title: 'Доступ к самым передовым производствам страны.',
        text: 'Регулярное участие в экскурсиях на самых передовых предприятиях столицы.',
      },
      {
        title: 'Офис в двух шагах от метро.',
        text: 'Расположение офиса на станции м. Деловой центр. Даже в самый сильный дождь вы доберётесь до работы, не намокнув (всего несколько шагов от метро до башни!).',
      },
      {
        title: 'Дополнительные бонусы.',
        text: 'К ежегодному отпуску - материальная помощь, а в конце года - премия.',
      },
      {
        title: 'Рост и развитие.',
        text: 'Доступ к корпоративному обучению от сервисов Правительства Москвы.',
      },
      {
        title: 'Жизнь вне рабочих задач.',
        text: 'Квизы, соревнования и яркие мероприятия.',
      },
    ],
  },
  {
    id: 'specialist',
    cardTitle: 'Ведущий специалист',
    fullTitle:
      'Ведущий специалист\nУправления специальных проектов\nи конгрессно – выставочной деятельности',
    photo: specialistPhoto,
    tasks: [
      'Координация подготовки и проведения профильных форумов и мероприятий',
      'Ведение полного цикла документооборота по проектам (входящие/исходящие документы, согласования, архивирование)',
      'Работа с системой МосЭДО, контроль сроков исполнения поручений',
      'Интеграция представителей Департамента в ключевые профильные форумы и мероприятия',
      'Работа с проектной документации (технические задания, программы мероприятий, регламенты, протоколы)',
      'Взаимодействие с подрядчиками и контроль выполнения договорных обязательств в рамках реализации таких проектов как: Петербургский международный экономический форум, Международная промышленная выставка «Иннопром», Форум будущих технологий, Восточный экономический форум и другие.',
      'Работа с партнёрами – привлечение и взаимодействие с ключевыми игроками отрасли, работа с гос.сектором и подведомственными организациями, институтами развития',
      'Реализация собственных профильных мероприятий и форумов – от идеи и концепции проекта до его проведения',
      'Подготовка отчётных материалов, аналитических справок и презентаций.',
    ],
    fit: [
      {
        title: 'Есть профильное образование.',
        text: 'Вы окончили вуз по направлению «Менеджмент», «Государственное и муниципальное управление».',
      },
      {
        title: 'Наработали практический опыт.',
        text: 'Работали в федеральных или столичных органах исполнительной власти или госкорпорациях, учреждениях по работе с молодёжью.',
      },
      {
        title: 'Умеете организовывать события.',
        text: 'Опыт подготовки массовых мероприятий.',
      },
      {
        title: 'Владеете офисными инструментами.',
        text: 'Готовите документы, сводите таблицы, делаете презентации.',
      },
      {
        title: 'Обладаете «мягкими» навыками.',
        text: 'Ответственно подходите к задачам, легко находите общий язык с людьми, умеете работать в условиях многозадачности и сохранять хладнокровие.',
      },
      {
        title: 'Готовы к динамичной работе.',
        text: 'Понимаете, что иногда потребуется выйти за рамки стандартного графика.',
      },
      {
        title: 'Знаете правила делового общения.',
        text: 'Ориентируетесь в нормах этикета: от переписки до личных встреч.',
      },
    ],
    offer: [
      {
        title: 'Достойное вознаграждение.',
        text: 'Предлагаем конкурентоспособную зарплату.',
      },
      {
        title: 'Заряжающие энергией задачи.',
        text: 'Интересные, масштабные проекты и все необходимые ресурсы для их воплощения.',
      },
      {
        title: 'Проекты уровня первых лиц.',
        text: 'Вы будете участвовать в организации мероприятий с участием руководства Правительства Москвы – это уникальный опыт и возможность увидеть работу системы изнутри.',
      },
      {
        title: 'Работа с молодёжной аудиторией.',
        text: 'Самая динамичная и заряжающая целевая аудитория. Вы сможете влиять на формирование профессионального будущего ребят.',
      },
      {
        title: 'Доступ к самым передовым производствам страны.',
        text: 'Регулярное участие в экскурсиях на самых передовых предприятиях столицы.',
      },
      {
        title: 'Офис в двух шагах от метро.',
        text: 'Расположение офиса на станции м. Деловой центр. Даже в самый сильный дождь вы доберётесь до работы, не намокнув (всего несколько шагов от метро до башни!).',
      },
      {
        title: 'Дополнительные бонусы.',
        text: 'К ежегодному отпуску - материальная помощь, а в конце года - премия.',
      },
      {
        title: 'Рост и развитие.',
        text: 'Доступ к корпоративному обучению от сервисов Правительства Москвы.',
      },
      {
        title: 'Жизнь вне рабочих задач.',
        text: 'Квизы, соревнования и яркие мероприятия.',
      },
    ],
  },
  {
    id: 'corrector',
    cardTitle: 'Корректор текстов',
    fullTitle: 'Корректор',
    photo: correctorPhoto,
    tasks: [
      'Вычитка исходящих писем, направляемых в вышестоящие инстанции;',
      'Вычитка презентаций для руководства;',
      'Корректура локальных нормативных актов (ЛНА) с устранением ошибок;',
      'Исправление орфографических и пунктуационных ошибок;',
      'Обеспечение стилистического единообразия текстов;',
      'Контроль лексической корректности формулировок;',
      'Фиксация всех выявленных замечаний и правок в проверенных документах;',
      'Мониторинг соблюдения нормативных требований к оформлению официальной документации.',
    ],
    fit: [
      {
        title: 'Есть профильное образование.',
        text: 'Вы окончили вуз по направлениям «Филология», «Лингвистика», «Журналистика» либо прошли профильную программу профессиональной переподготовки по редакторскокорректорской работе.',
      },
      {
        title: 'Наработали практический опыт.',
        text: 'Работали корректором, редактором или техническим писателем не менее 2 лет — в издательствах, медиа, корпоративных коммуникациях либо в крупных организациях с высоким объёмом документооборота.',
      },
      {
        title: 'Владеете нормами русского языка на экспертном уровне.',
        text: 'Вы уверенно ориентируетесь в орфографии, пунктуации и стилистике, знаете актуальные редакции справочников Розенталя и академических правил, применяете их в ежедневной практике.',
      },
      {
        title: 'Умеете работать в режиме рецензирования и с правками.',
        text: 'Вы свободно используете инструменты рецензирования в MS Word, отслеживаете изменения, аргументируете правки и согласовываете их с авторами без потери смысла текста.',
      },
      {
        title: 'Уверенно работаете с большими объёмами текстов в сжатые сроки.',
        text: 'Вы способны качественно вычитывать объёмные материалы, расставлять приоритеты и укладываться в дедлайны без потери качества.',
      },
    ],
    offer: [
      {
        title: 'Достойное вознаграждение.',
        text: 'Предлагаем конкурентоспособную зарплату.',
      },
      {
        title: 'Офис в двух шагах от метро.',
        text: 'Расположение офиса на станции м. Деловой центр. Даже в самый сильный дождь вы доберётесь до работы, не намокнув (всего несколько шагов от метро до башни!).',
      },
      {
        title: 'Дополнительные бонусы.',
        text: 'К ежегодному отпуску - материальная помощь, а в конце года - премия.',
      },
      {
        title: 'Рост и развитие.',
        text: 'Доступ к корпоративному обучению от сервисов Правительства Москвы.',
      },
      {
        title: 'Жизнь вне рабочих задач.',
        text: 'Квизы, соревнования и яркие мероприятия.',
      },
    ],
  },
];

export const DEPARTMENTS = [
  {
    id: 'kvd',
    title: 'Управление КВД\nи спецпроектов',
    photo: deptKvd,
  },
  {
    id: 'export',
    title: 'Управление экспортной\nдеятельности',
    photo: deptExport,
  },
  {
    id: 'industry',
    title: 'Управление сопровождения промышленности',
    photo: deptIndustry,
  },
];

export const SEE_ALSO = [
  {
    id: 'news',
    title: 'Новости',
    to: routes.media.news.root,
    image: linkNews,
  },
  {
    id: 'events',
    title: 'Мероприятия',
    to: routes.events.root,
    image: linkEvents,
  },
  {
    id: 'resolutions',
    title: 'Меры поддержки',
    to: routes.resolutions.root,
    image: linkResolutions,
  },
  {
    id: 'analytics',
    title: 'Аналитика',
    to: `${routes.resolutions.service.root}/analytics`,
    image: linkAnalytics,
  },
];
